import { Controller } from "@hotwired/stimulus"
import { get } from "@rails/request.js"
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules'

export default class extends Controller {

  connect() {
    Swiper.use([Navigation, Pagination]);
    const swiper1 = new Swiper('.slide-listas-swiper', {
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },   
      pagination: {
          el: '.swiper-pagination',
          type: "fraction",
      }
    });

    let button_sub_menu =document.querySelectorAll('.box-sub-menu .button-sub-menu');
    for (let i = 0; i < button_sub_menu.length; i++) {
      button_sub_menu[i].addEventListener('click', function (e) {
        this.classList.add("active")
        let paretnElement = this.parentNode.querySelector(".sub-menu-doctos")
        paretnElement.classList.toggle("active")
        paretnElement.onmouseleave = function(){
          this.classList.remove("active")
          button_sub_menu[i].classList.remove("active")
        };
      })
    }
    let serch_container=document.querySelectorAll(".serch-container")
    let close_filters=document.querySelectorAll(".serch-container .close-filters")
    let open_filters=document.querySelectorAll(".serch-mobile-container .open-filters")
    
    for (let i = 0; i < close_filters.length; i++) {
      close_filters[i].addEventListener('click', function (e) {
        serch_container[i].classList.toggle("active")
      })
    }
    
    for (let i = 0; i < open_filters.length; i++) {
      open_filters[i].addEventListener('click', function (e) {
        serch_container[i].classList.toggle("active")
      })
    }

    let docto_select_table= document.getElementById("docto_select_table")
    let box_container_documentos = document.querySelectorAll(".box-container-documentos")
    docto_select_table?.addEventListener('change', (event) => {
      let table_select = docto_select_table.value
      for (var i = 0; i< box_container_documentos.length; i++) {
        box_container_documentos[i].classList.remove("active");
     }
     document.querySelector("."+table_select).classList.add("active")
    });

    let active_dicataminar = document.querySelectorAll(".botonera-dictaminar .button")
    for (let i = 0; i < active_dicataminar.length; i++) {
      active_dicataminar[i].addEventListener('click', function (e) {
        for (var j = 0; j< active_dicataminar.length; j++) {
          active_dicataminar[j].classList.remove("active");
        }
        this.classList.add("active");
      })
    }
  }
}
